import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import MillieApi    from 'app/apis/millie';
import Modal        from 'app/components/common/modal';
import SortableList from 'app/components/common/sortable-list';
import {
  CampaignTempTypes as TempTypes,
}                   from 'app/constants';
import helpers      from 'app/helpers/campaigns';

class ModalSortCampaignTemplates extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      type: TempTypes.EVERGREEN,
      map: {},
      isSaving: false,
    };

    this.onClose = this.onClose.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.onSort = this.onSort.bind(this);
    this.renderCampaign = this.renderCampaign.bind(this);
  }

  get campaigns() {
    const filtered = (this.props.allCampaigns || []).filter(c => c.temporalityType === this.state.type);
    return filtered.sort((a, b) => {
      const aIndex = this.getSortIndex(a);
      const bIndex = this.getSortIndex(b);
      return aIndex - bIndex;
    });
  }

  getSortIndex(camp) {
    const {map} = this.state;
    if (_.isFinite(map[camp.id])) return map[camp.id];
    return camp.sortIndex || 0;
  }

  componentDidMount() {
  }

  onClose() {
    this.props.onClose(false);
  }

  onClickType(type) {
    this.setState({type});
  }

  onSort(campaigns) {
    const newMap = {};
    campaigns.forEach((camp, i) => {
      newMap[camp.id] = i + 1;
    });
    this.setState((prevState) => {
      const map = {...prevState.map, ...newMap};
      return {map};
    });
  }

  onClickSave() {
    this.setState({isSaving: true});
    MillieApi.campaignsTemplatesSort(this.state.map).then(() => {
      this.setState({isSaving: false});
      this.props.onClose(true);
    }).catch((error) => {
      alert('oops it broke :(');
      console.error(error);
      this.setState({isSaving: false});
    });
  }

  renderCampaign(campaign, index, dnd) {
    return (
      <div className={`_p-12 _border _border-all _flex _justify-start _align-center _gap-12 ${dnd.isActive ? '_border-midnight' : ''} ${dnd.isTarget ? '_bg-slate' : ''}`}>
        {dnd.handleEl}
        <div>{campaign.name}</div>
      </div>
    );
  }

  render() {
    const {type, map, isSaving} = this.state;

    return (
      <Modal className="bform" onClose={this.onClose}>
        <h1 className="bform-h1">Sort Campaign Templates</h1>

        <div className="_mt-24 _flex _justify-start _align-center _gap-12 _flex-wrap">
          {Object.values(TempTypes).map((tempType) => {
            const isActive = tempType === type;
            return (
              <button className={`btn small ${isActive ? '' : 'secondary ghost'}`} key={tempType} onClick={this.onClickType.bind(this, tempType)}>{helpers.getTemporalityLabel(tempType)}</button>
            );
          })}
        </div>

        <div className="_flex _col _gap-6 _justify-start _align-stretch _mt-24">
          <SortableList items={this.campaigns} renderItem={this.renderCampaign} onSort={this.onSort} />
        </div>

        {/* <pre>{JSON.stringify({map},null,4)}</pre> */}

        <div className="bform-actions">
          <button className="btn blue" onClick={this.onClickSave} disabled={isSaving}>{isSaving ? 'Saving...' : 'Save'}</button>
        </div>
      </Modal>
    );
  }

}

ModalSortCampaignTemplates.propTypes = {
  allCampaigns: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClose: PropTypes.func.isRequired,
};
ModalSortCampaignTemplates.defaultProps = {
};

export default ModalSortCampaignTemplates;
